import React from 'react';

import './AddPageContent.scss';
import Icon from 'Core/Components/Icon';

import { CONTENT_TYPES } from 'Core/Utils/ContentUtils';

class AddPageContent extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      adding: false
    };
    this.startAdd = this.startAdd.bind(this);
    this.cancelAdd = this.cancelAdd.bind(this);
    this.renderTypeList = this.renderTypeList.bind(this);
  }

  startAdd () {
    this.setState({ adding: true });
  }

  cancelAdd () {
    this.setState({ adding: false });
  }

  renderTypeList () {
    const { onContentAdd } = this.props
    if (typeof onContentAdd !== 'function') return null;
    return (
      <div className="AddPageContent-ContentSelection">
        {CONTENT_TYPES.map((type, index) => (
          <div
            key={index}
            className="AddPageContent-ContentType"
            onClick={() => onContentAdd(type.id, type.editor.getInitialShape()) || this.cancelAdd()}>
            <img src={type.image}/>
            <h3 className="display">{type.name}</h3>
            <p>{type.description}</p>
          </div>
        ))}
      </div>
    );
  }

  render () {
    const { adding } = this.state;
    const TypeList = this.renderTypeList;
    return (
      <div className={'AddPageContent' + (adding ? ' open' : '')} onClick={() => adding ? null : this.startAdd()}>
        {!adding
          ? (
            <div className="row items-center justify-center">
              <Icon fa="plus-square-o" />
              <big>Add a section</big>
            </div>
          )
          : (
            <React.Fragment>
              <big>Add Content</big>
              <TypeList/>
              <button onClick={this.cancelAdd}>
                <Icon fa="times-circle"/>
                Cancel
              </button>
            </React.Fragment>
          )
        }
      </div>
    )
  }
};

export default AddPageContent;



// WEBPACK FOOTER //
// ./client/RLX/Views/Dashboard/Panes/PageEditor/PageContent/AddPageContent.jsx